import { render, staticRenderFns } from "./EditVideos.vue?vue&type=template&id=1dfd1489&"
import script from "./EditVideos.vue?vue&type=script&lang=js&"
export * from "./EditVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports